import { css } from '@emotion/react';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const plainButtonStyle = css({
  backgroundColor: 'transparent',
  border: 'none',
  color: 'inherit',
  cursor: 'pointer',
  fontSize: 'inherit',
  outline: 'none',
  padding: '0',
});
